module.exports = __webpack_public_path__ + "img/baiyulan-portfolio.d4e44ee3.jpg";